import Vue from 'vue';
import Vuex from 'vuex';
// import createPersist from 'vuex-localstorage'
import auth from './modules/auth';
import date from './modules/date';
import charaNavi from './modules/chara-navi';
import page from './modules/page';
import inview from './modules/inview';
import loader from './modules/loader';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'

// let localStorage = createPersist({
//     namespace: 'YOUR_APP_NAMESPACE',
//     initialState: {},
//     expires: 1.21e+9 // Two Weeks
// })

export default new Vuex.Store({
	// actions,
	// getters,
	modules: {
		auth,
		date,
		charaNavi,
		page,
		inview,
		loader,
	},
	// strict: debug,
	// plugins: [localStorage]
})
